import React, { useMemo, useState, useEffect, useRef } from 'react'
import { isRowAveragesUid } from '@aytm/app/insights/dashboard/lib/config'
import PropTypes from 'prop-types'

import Tag from './Tag'

const Tags = props => {
  const containerRef = useRef()

  const readOnly = useMemo(() => !props.editorMode || isRowAveragesUid(props.uid), [props.editorMode, props.uid])

  const tags = useMemo(() => props.tags || [], [props.tags])

  const [mounted, setMounted] = useState(false)

  const onUpdate = event => {
    if (props.onUpdate) {
      if ('update' === event.action && event.index >= 0 && event.tag && event.tag.trim() !== '') {
        const newTags = tags.map((v, i) => (event.index === i ? event.tag : v))
        props.onUpdate({ action: 'update', uid: props.uid, tags: newTags })
      } else if ('delete' === event.action && event.index >= 0) {
        const newTags = tags.filter((_v, i) => event.index !== i)
        props.onUpdate({ action: 'update', uid: props.uid, tags: newTags, deleted: tags[event.index] })
      } else if (
        'add' === event.action &&
        event.tag &&
        event.tag.trim() !== '' &&
        !tags.includes(event.tag.trim()) &&
        tags.length < 25
      ) {
        const newTags = tags.concat(event.tag)
        props.onUpdate({ action: 'update', uid: props.uid, tags: newTags })
      }
    }
  }

  const renderTags = () => {
    if (mounted) {
      const rect = containerRef.current.getBoundingClientRect()
      const style = { maxWidth: `${rect.width - 8}px` }
      return mounted && Array.isArray(tags)
        ? tags.map((v, i) => (
            <Tag
              style={style}
              className={`${props.className}-tag`}
              tag={v}
              key={`${props.uid}-${i}`}
              index={i}
              wait={props.wait || readOnly}
              onUpdate={onUpdate}
            />
          ))
        : null
    } else return null
  }

  const renderAdd = () =>
    mounted && !readOnly ? (
      <Tag
        className={`${props.className}-tag`}
        add={true}
        editing={true}
        wait={props.wait || readOnly}
        onUpdate={onUpdate}
      />
    ) : null

  useEffect(() => {
    if (!mounted) setMounted(true)
  }, [mounted])

  return (
    <div ref={containerRef} className={props.className}>
      {renderAdd()}
      {renderTags()}
    </div>
  )
}

Tags.propTypes = {
  className: PropTypes.string,
  uid: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  wait: PropTypes.any,
  editorMode: PropTypes.any,
  onUpdate: PropTypes.func
}

export default Tags
